import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDetyratTasks = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 22.2 20",
	style: { enableBackground: "new 0 0 22.2 20" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n	.st2{clip-path:url(#SVGID_00000130615147645718039340000001940184571261041076_);}\n	.st3{clip-path:url(#SVGID_00000081634595598250897940000013946659566164430746_);}\n	.st4{fill:#F2F2F2;}\n	.st5{fill:#BDB6B8;}\n	.st6{fill:#1A1A1A;}\n	.st7{fill:#ADA8AA;}\n	.st8{fill:#262424;}\n	.st9{fill:#1E8273;}\n	.st10{fill:#239281;}\n	.st11{fill:#262626;}\n	.st12{fill:#0F0F0F;}\n	.st13{fill:#212226;}\n	.st14{opacity:0.25;}\n	.st15{clip-path:url(#SVGID_00000147902265065797746470000000950458959576866217_);}\n	.st16{opacity:0.15;}\n	.st17{clip-path:url(#SVGID_00000137818447696860063650000009987073030969580969_);}\n		"
	}), /* @__PURE__ */ _jsx("g", {
		id: "Group_4171_00000070798949537746889240000010340651942030331532_",
		transform: "translate(-2 -3)",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Group_4170_00000165937525434866985520000014923681067384462471_",
			transform: "translate(2 3)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_7415_00000134212190235252654350000000058067522740290455_",
				className: "st1",
				d: "M20,0H2.2C1,0,0,1,0,2.2v15.6 C0,19,1,20,2.2,20H20c1.2,0,2.2-1,2.2-2.2V2.2C22.2,1,21.2,0,20,0z M7.8,15.6H4.4c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h3.3 c0.6,0,1.1,0.5,1.1,1.1S8.4,15.6,7.8,15.6z M7.8,11.1H4.4c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h3.3c0.6,0,1.1,0.5,1.1,1.1 S8.4,11.1,7.8,11.1z M7.8,6.7H4.4c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h3.3c0.6,0,1.1,0.5,1.1,1.1S8.4,6.7,7.8,6.7z M18.6,9 L15,12.5c-0.4,0.4-1.1,0.4-1.6,0L11.9,11c-0.4-0.4-0.4-1.1,0-1.6s1.1-0.4,1.6,0l0.8,0.8L17,7.4c0.4-0.4,1.1-0.4,1.6,0c0,0,0,0,0,0 l0,0C19,7.9,19,8.6,18.6,9L18.6,9z"
			})
		})
	})]
});
export { SvgIconDetyratTasks as ReactComponent };
